import styled from 'styled-components'
import Card from '@bit/wavfichacerta.fichacerta.cards.card'
import { MainContainer as MC, PageContainer } from '@bit/wavfichacerta.fichacerta.shared-styles.containers';
import { Link } from 'react-router-dom';

export const MainContainer = styled(MC)`
      @media (max-width: 800px) {
            padding-left: 0;
            width: 95%;
            margin-top: 33%;
      }
`;

export const StyledLink = styled(Link)`
      display: block;
      box-sizing: border-box;
      width: calc(50% - 11px);
      text-decoration: none;
      &:focus, &:hover, &:visited, &:link, &:active {
      text-decoration: none;
      }

      @media (max-width: 800px) {
            width: 100%;
      }
`;

export const StyledLinkWithoutTo = styled.div`
      display: block;
      box-sizing: border-box;
      width: calc(50% - 11px);
      text-decoration: none;
      &:focus, &:hover, &:visited, &:link, &:active {
      text-decoration: none;
      }

      @media (max-width: 800px) {
            width: 100%;
      }
`;

export const DashCard = styled(Card) `
      display: block;
      width: 100%;
      max-width: 360px;
      height: 260px;
      margin: 0;
      overflow: hidden;
      border: 1px solid rgba(21, 43, 78, 0.06);
      background-color: #fff;
      box-shadow: 0 4px 24px rgba(21, 43, 78, 0.06);
      border-radius: 14px;
      transition: transform 0.18s cubic-bezier(0.4, 0, 0.2, 1),
            box-shadow 0.18s cubic-bezier(0.4, 0, 0.2, 1),
            border-color 0.18s cubic-bezier(0.4, 0, 0.2, 1);
     
     &:hover {
            border-color: rgba(21, 43, 78, 0.24);
            box-shadow: 0 10px 28px rgba(21, 43, 78, 0.12);
            transform: translateY(-2px);
            cursor: pointer;
      }

      svg, path {
            fill: #ff7200 !important;
            opacity: 1 !important;
      }

      @media (max-width: 800px) {
            height: 160px;
            padding: 10px;
            border-radius: 12px;

            &:hover {
                  transform: none;
                  border-color: rgba(21, 43, 78, 0.06);
                  box-shadow: 0 4px 24px rgba(21, 43, 78, 0.06);
            }

            .main-icon {
                  margin-right: -38px;
                  transform: scalex(-1);
                  margin-top: 28px;
            }
            .sac-icon {
                  margin-top: 36px;
            }
      }
`

export const CardContainer = styled.div`
      width: 100%;
      max-width: 760px;
      margin: 0 auto 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 22px;

      @media (max-width: 800px) {
            gap: 14px;
            margin: 0 auto 14px;
      }
      `

export const DashCardSlot = styled.div`
      width: calc(50% - 11px);
      position: relative;

      & > a,
      & > div {
            width: 100%;
      }

      @media (max-width: 800px) {
            width: 100%;
      }
`;

/** Contexto de posicionamento do TourTooltip: mesmo width do DashCard (evita ? fora do card no mobile largo). */
export const DashCardFrame = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
`;

export const CardTitle = styled.h1`
      display: block;
      font-size: 15px;
      text-transform: uppercase;
      color: #152b4e;
      text-align: center;
      
      @media (max-width: 800px) {
            text-align: left;
            font-weight: 500;
      }

      @media (max-width: 349px) {
            margin-bottom: 0;
      }
`
export const CardDescription = styled.p`
      display: block;
      font-size: 12px;
      color: #7f7f7f;
      text-align: center;
      margin-top: 0;
      margin-bottom: 16px;
      
`

export const StyledTextArea = styled.textarea`
      font-size: 12px;
      resize: none;
      width: 100%;
      margin-top: 5%;
      height: 109px;
      margin-bottom: 4%;
`
export const StyledSubject = styled.h2`
      font-size: 12px;
      color: #6c757d
`
export const StyledPageContainer = styled(PageContainer)`
      background-color: var(--fc-bg-page, #ffffff);
      min-height: 100vh;
      @media (max-width: 800px){
            width: 100%;
      }
`